<template>
  <div class="carousel">
    <div class="carousel-container">
      <button class="nav left" @click="prevSlide">‹</button>

      <div :class="['image-wrapper', { 'transitioning': isTransitioning, 'not-transitioning': !isTransitioning }]"
        @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
        <img :src="imageData[currentIndex].src" :alt="imageData[currentIndex].location" />
        <div class="location-tag">{{ imageData[currentIndex].location }}</div>
      </div>

      <button class="nav right" @click="nextSlide">›</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const imageData = [
  { src: require('@/assets/melhores-passeios/estrela-do-formoso.jpg'), location: 'Estrela do Formoso - Foto' },
  { src: require('@/assets/melhores-passeios/nascente-azul.jpg'), location: 'Nascente Azul - Foto' },
  { src: require('@/assets/melhores-passeios/praia-da-figueira.jpg'), location: 'Praia da Figueira - Foto' },
]

const currentIndex = ref(0)
const isTransitioning = ref(false)
const autoPlayInterval = ref(null)

// Touch variables
const touchStartX = ref(0)
const touchEndX = ref(0)
const isDragging = ref(false)

const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % imageData.length
  isTransitioning.value = true
  setTimeout(() => {
    isTransitioning.value = false
  }, 1)
}

const prevSlide = () => {
  currentIndex.value = (currentIndex.value - 1 + imageData.length) % imageData.length
  isTransitioning.value = true
  setTimeout(() => {
    isTransitioning.value = false
  }, 1)
}

// Touch handlers
const handleTouchStart = (e) => {
  touchStartX.value = e.touches[0].clientX
  touchEndX.value = e.touches[0].clientX
  isDragging.value = false
  stopAutoPlay()
}

const handleTouchMove = (e) => {
  touchEndX.value = e.touches[0].clientX
  const diff = Math.abs(touchStartX.value - touchEndX.value)

  if (diff > 10) {
    isDragging.value = true
    e.preventDefault()
  }
}

const handleTouchEnd = () => {
  if (!isDragging.value) {
    startAutoPlay()
    return
  }

  const swipeThreshold = 50
  const diff = touchStartX.value - touchEndX.value

  if (Math.abs(diff) > swipeThreshold) {
    if (diff > 0) {
      // Swipe left - next slide
      nextSlide()
    } else {
      // Swipe right - previous slide
      prevSlide()
    }
  }

  isDragging.value = false
  startAutoPlay()
}

const startAutoPlay = () => {
  autoPlayInterval.value = setInterval(nextSlide, 10000)
}

const stopAutoPlay = () => {
  if (autoPlayInterval.value) {
    clearInterval(autoPlayInterval.value)
    autoPlayInterval.value = null
  }
}

onMounted(() => {
  startAutoPlay()
})

onUnmounted(() => {
  stopAutoPlay()
})
</script>

<style scoped lang="scss">
.carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  /* touch-action: pan-y pinch-zoom; */
}

.carousel-container {
  width: 100%;
  height: 215px;
  position: relative;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 1);

}

.transitioning {
  opacity: 0 !important;
}

.not-transitioning {
  opacity: 1 !important;
  transition: opacity 0.3s ease-in-out;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 1;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.location-tag {
  position: absolute;
  top: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 20px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  z-index: 5;
}

.nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  cursor: pointer;
  z-index: 10;
  transition: background 0.3s;
  user-select: none;
  background: transparent;
  border-radius: 50px !important;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}

.nav.left {
  left: -36px;
}

.nav.right {
  right: -36px;
}

@media (max-width: 1024px) {
  .carousel-container {
    height: 180px;
  }

  .nav {
    width: 32px;
    height: 32px;
    font-size: 20px;
  }

  .nav.left {
    left: -40px;
  }

  .nav.right {
    right: -40px;
  }
}

@media (max-width: 540px) {
  .carousel-container {
    height: 200px;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
    /* touch-action: pan-x; */

    img {
      border-radius: 0;
    }
  }

  .location-tag {
    top: 8px;
    left: 8px;
    padding: 4px 12px;
    font-size: 12px;
  }

  .nav {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }

  .nav.left {
    left: 10px;
  }

  .nav.right {
    right: 10px;
  }
}
</style>
